import { createSlice } from '@reduxjs/toolkit';

export const permissonsSlice = createSlice({
    name: 'permissions',
    initialState: {
        permissions: [],
        user_permissions: []
    },
    reducers: {
        setPermissions: ( state,  { payload }  ) => {
            state.permissions = payload;
        },
        setUserPermissions: ( state,  { payload }  ) => {
            state.user_permissions = payload;
        },
        
    }
});


// Action creators are generated for each case reducer function
export const { setPermissions, setUserPermissions } = permissonsSlice.actions;